import React from 'react';
import InforGraphics from '../../../Assets/Home/infographic_kapil.png'
import { Link } from 'react-router-dom';
const ITConsultingSection = () => {
  return (
    <section className="relative py-16 sm:py-20 lg:py-24 overflow-hidden" style={{ background: "linear-gradient(to bottom right, #F0F7FF, #E6E6FA)" }}>
      {/* Decorative background elements */}
      {/* <div className="absolute top-0 right-0 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" style={{ backgroundColor: "#2563EB" }}></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" style={{ backgroundColor: "#7C3AED" }}></div>
      <div className="absolute top-1/2 left-1/4 w-64 h-64 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-pulse" style={{ backgroundColor: "#2DD4BF" }}></div>
       */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left Side Image with responsive design */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-1 rounded-lg blur opacity-25" ></div>
              <div className="relative overflow-hidden ">
                <img
                  src={InforGraphics}
                  alt="IT Consulting Services"
                  className="w-full h-auto object-cover transition-transform duration-500 hover:scale-105"
                />
                <div className="absolute inset-0 opacity-40" ></div>
              </div>
            </div>
          </div>
          
          {/* Right Side Content with improved typography */}
          <div className="w-full lg:w-1/2 order-1 lg:order-2">
            <div className="space-y-6">
              <div>
                <h4 className="text-sm uppercase tracking-wider font-semibold mb-1" style={{ color: "#2563EB" }}>Expert Solutions</h4>
                <h2 className="text-3xl sm:text-4xl font-bold leading-tight" style={{ color: "#1E293B" }}>
                  Empowering Businesses with  Comprehensive ERP Solutions
                </h2>
              </div>
              
              <div className="w-16 h-1 rounded-full" style={{ background: "linear-gradient(to right, #2563EB, #4F46E5)" }}></div>
              
              <p className="text-md leading-relaxed" style={{ color: "#475569" }}>
                We Specialize In ERP Services, Including Infor Consulting, SAP Staffing, End-to-End Implementations, Upgrades, Cloud Solutions and Integrations. Our Tailored Solutions Streamline your Business Operations, Enhance Productivity and Drive Digital Transformation. With 24/7 Support and Expertise In Data Analytics and Security, We Empower Businesses Across Industries to Achieve Growth And Innovation Globally.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                <div className="flex items-center">
                  <div className="flex-shrink-0 p-2 rounded-md" style={{ backgroundColor: "#DBEAFE" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#2563EB">
                      <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="ml-3" style={{ color: "#334155" }}>Strategic Planning</span>
                </div>
                <div className="flex items-center">
                  <div className="flex-shrink-0 p-2 rounded-md" style={{ backgroundColor: "#DBEAFE" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#2563EB">
                      <path fillRule="evenodd" d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="ml-3" style={{ color: "#334155" }}>Custom Solutions</span>
                </div>
                <div className="flex items-center">
                  <div className="flex-shrink-0 p-2 rounded-md" style={{ backgroundColor: "#DBEAFE" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#2563EB">
                      <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                      <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                    </svg>
                  </div>
                  <span className="ml-3" style={{ color: "#334155" }}>Data Analytics</span>
                </div>
                <div className="flex items-center">
                  <div className="flex-shrink-0 p-2 rounded-md" style={{ backgroundColor: "#DBEAFE" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="#2563EB">
                      <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="ml-3" style={{ color: "#334155" }}>Security Services</span>
                </div>
              </div>
              
              <button className="px-6 py-3 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5" 
                style={{ background: "linear-gradient(to right, #2563EB, #4F46E5)" }}>
                 <Link to="/contact">Get a Free Consultation</Link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ITConsultingSection;